// LIBRERIE/IMPORTS
import React from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface ServicesSectionProps {
  agencyName: string;
  showServices: boolean;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ agencyName, showServices }) => {
  const { t } = useTranslation();

  if (!showServices) return null;

  const servicesLinkTitle = t('navigation.servicesLinkTitle');
  const sellLinkTitle = t('navigation.sellLinkTitle');
  const searchLinkTitle = t('navigation.searchLinkTitle');
  const contactButtonText = t('homePage.agencyInfoSnippet.contactButton');

  return (
    <section className="space-ptb bg-green" id="agency-services-promo">
      <div className="container">
        <div className="row align-items-center justify-content-center">

          {/* Colonna Sinistra: Link Servizi */}
          <div className="col-12 col-lg-6">
            <ul className="mb-5 mb-lg-0">

              {/* Link Servizi */}
              <li className="d-flex align-items-center justify-content-start mb-4">
                <Link to="/servizi" title={servicesLinkTitle ?? ''}>
                  <FontAwesomeIcon icon={faArrowCircleRight} className="mr-3 text-primary fa-lg" size="xl"/>
                </Link>
                <p className="m-0">{t('homePage.servicesSection.servicesDescription')}</p>
              </li>

              {/* Link Vendi */}
              <li className="d-flex align-items-center justify-content-start mb-4">
                <Link to="/vendi" title={sellLinkTitle ?? ''}>
                  <FontAwesomeIcon icon={faArrowCircleRight} className="fas fa-arrow-circle-right mr-3" size="xl"/>
                </Link>
                <p className="m-0">
                  {t('homePage.servicesSection.sellDescription')}
                </p>
              </li>

              {/* Link Cerca */}
              <li className="d-flex align-items-center justify-content-start mb-4">
                <Link to="/immobili" title={searchLinkTitle ?? ''}>
                  <FontAwesomeIcon icon={faArrowCircleRight} className="mr-3 text-primary fa-lg" size="xl"/>
                </Link>
                <p className="m-0">
                  {t('homePage.servicesSection.searchDescription')}
                </p>
              </li>

            </ul>
          </div>

          {/* Colonna Destra: Info Agenzia */}
          <div className="col-12 col-sm-10 col-lg-6 text-center">
            <div className="bg-white p-3">

              <h3 className="mb-3">{agencyName}</h3>
              <p>{t('homePage.agencyInfoSnippet.specialization')}</p>
              <p>{t('homePage.agencyInfoSnippet.support')}</p>
              <p className="mb-4">{t('homePage.agencyInfoSnippet.contact')}</p>

              {/* Bottone Contatti */}
              <Link to="/contatti" title={contactButtonText ?? ''} className="btn btn-primary">
                {contactButtonText}
              </Link>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;